export default __webpack_public_path__ + "static/media/sponsor-watermark.13ad399c.png";